module.exports = __webpack_public_path__ + "img/LogoH35-02.ca130749.png";